// Web component para controlar la cantidad de un ítem en el cart drawer
// Se encarga de manejar clicks en + / - y emitir eventos para que cart-drawer
// reciba los datos necesarios para actualizar el carrito

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');              // input de cantidad del ítem en el drawer
    this.variantId = this.dataset.variantId;               // id de variante asociada a este quantity-input
    this.productTitle = this.dataset.title;                // título del producto asociado a este quantity-input
     
    // Escucha clicks en los botones + / - del componente
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const currentValue = parseInt(this.input.value);       // cantidad actual visible en el input
    const lineIndex = this.input.dataset.index;            // índice de línea en el cart (Shopify)
    const inStock = parseInt(this.input.dataset.stock);    // stock máximo permitido para esta línea
    const productTitle = this.productTitle;               // título del producto para mostrar en notificaciones
    const variantId = this.variantId;                     // ID de la variante para identificar el producto en el carrito
    const message = `${window.globalTranslations.updateToCart}`; // mensaje traducido para la notificación

    let newQuantity = null;

    // Manejo del botón +
    if (event.target.name === 'plus') {
      // Solo permitimos sumar si no se supera el stock
      if (currentValue < inStock) {
        this.input.stepUp();                               // actualizamos el valor del input en el DOM
        newQuantity = currentValue + 1;

        // Debounce: si hay un timeout pendiente lo cancelamos para no mandar peticiones innecesarias
        if (this.updateTimeout) {
          clearTimeout(this.updateTimeout);
        }

        // Programamos la emisión del evento con delay para evitar múltiples eventos
        this.updateTimeout = setTimeout(() => {
          // Emitimos evento con datos de cantidad y línea para que cart-drawer lo procese

          this.dispatchEvent(new CustomEvent('pb:quantity:updated', {
            detail: {quantity: newQuantity, variantId, lineIndex, productTitle, message}, 
            bubbles: true
          }));
        }, 500);
      }
    } else { // Manejo del botón -
      // Solo permitimos restar si la cantidad es mayor que 0
      if (currentValue > 0) {
        this.input.stepDown();                             // actualizamos el valor del input en el DOM
        newQuantity = currentValue - 1;

        // Igual que en el botón +, aplicamos debounce
        if (this.updateTimeout) {
          clearTimeout(this.updateTimeout);
        }

        // Programamos la emisión del evento con delay para evitar múltiples eventos
        this.updateTimeout = setTimeout(() => {
          // Emitimos evento con datos de cantidad y línea para que cart-drawer lo procese          
          this.dispatchEvent(new CustomEvent('pb:quantity:updated', {
            detail: {quantity: newQuantity, variantId, lineIndex, productTitle, message}, 
            bubbles: true
          }));
        }, 500);
      }
    }
  }
}

customElements.define('quantity-input', QuantityInput);